export const SHARP_CORNERS = 'sharp';
export const ROUNDED_CORNERS = 'rounded';
